import { render, staticRenderFns } from "./ApiVariable.vue?vue&type=template&id=2fd623fc&scoped=true"
import script from "./ApiVariable.vue?vue&type=script&lang=js"
export * from "./ApiVariable.vue?vue&type=script&lang=js"
import style0 from "./ApiVariable.vue?vue&type=style&index=0&id=2fd623fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd623fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fd623fc')) {
      api.createRecord('2fd623fc', component.options)
    } else {
      api.reload('2fd623fc', component.options)
    }
    module.hot.accept("./ApiVariable.vue?vue&type=template&id=2fd623fc&scoped=true", function () {
      api.rerender('2fd623fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/ApiVariable.vue"
export default component.exports